import { useCallback, useState } from 'react'

import { HABILITADO } from 'common/constants'
import { map } from 'lodash'
import { TCommunications, TCommunicationType, TUserType } from 'contexts/app-context/types'
import { useAppContext } from 'contexts/app-context/hooks'

import {
  TCommunicatioMethods,
  TMeansOfCommunicationBR,
} from '../types/MeansOfCommunicationBr.types'
import { brCommunicationKeyToUsCommunicationKeyMapper } from '../utils/MeansOfCommunicationBr.utils'

export function useMeansOfCommunicationBr({ meiosDeComunicacao, values }: TMeansOfCommunicationBR) {
  const isGroupDisabled = values.find((toggle) => toggle.chave === HABILITADO)?.valor === false

  const { userAccountType } = useAppContext()
  const userType: TUserType = userAccountType ?? 'PF'
  const [showBottomsheet, setShowBottomsheet] = useState(false)
  const dontDisturbBottomsheetHandler = useCallback(() => {
    setShowBottomsheet((current) => !current)
  }, [setShowBottomsheet])

  const methods = (
    map(
      meiosDeComunicacao,
      (
        communication: TCommunications<TUserType>[TCommunicationType<typeof userType>],
        key: TCommunicationType<typeof userType>,
      ) => {
        if (!communication) return null
        const { name, icon } = communication

        const keyBR = brCommunicationKeyToUsCommunicationKeyMapper(userType)[key]

        const isActive = !!values.find((m) => m.chave === keyBR)?.valor

        const isDisabled = keyBR !== HABILITADO && isGroupDisabled

        const isDontDisturb = !!values.find((m) => m.chave === keyBR)?.isNaoPerturbe

        return {
          keyBR,
          isActive: keyBR === 'HABILITADO' ? !isActive : isActive,
          isDisabled,
          isDontDisturb,
          name,
          icon,
        }
      },
    ) as unknown as TCommunicatioMethods[]
  ).filter((communication) => communication)

  return {
    isGroupDisabled,
    showBottomsheet,
    dontDisturbBottomsheetHandler,
    methods,
  }
}
